import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import { NcziMessage } from '../../../../graphql/graphql';
import NcziQueueItem from './NcziQueueItem';

// @ts-ignore
import styles from './NcziQueuePanel.module.scss';

interface Props {
  opened: boolean
  onClose: () => void
  items: NcziMessage[]
}

const NcziQueuePanel: React.FC<Props> = props => {
  const { opened, onClose, items } = props;

  if(!opened) {
    return (
      <></>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.backdrop} />
      <div className={styles.sidebar}>
        <div className={styles.header}>
          <Text tx={'nczi.queue.title'} className={styles.title} firstUpper />
          <div className={styles.closeButton} onClick={onClose}>
            <img src="/dist/icons/close.svg" alt="close" />
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.content}>
            {items.map((item, key) => <NcziQueueItem item={item} key={key} />)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NcziQueuePanel;
